import { UserRole } from '../users/userRole.enum';

export enum Application {
  CARE = 'CARE',
  MEMBER = 'MEMBER',
  CONSENT = 'CONSENT',
  REPORTS = 'REPORTS',
}

export const roleApplicationsMappings = {
  [UserRole.ADMIN]: [Application.CARE],
  [UserRole.PATIENT]: [Application.MEMBER],
  [UserRole.SOCIAL_WORKER]: [Application.CARE],
  [UserRole.COMMUNITY_HEALTH_WORKER]: [Application.CARE],
  [UserRole.COMMUNITY_OUTREACH_SPECIALIST]: [Application.CARE],
  [UserRole.GUIDE]: [Application.CARE],
  [UserRole.MEMBER_ENROLLMENT_SPECIALIST]: [Application.CARE],
  [UserRole.GUIDE_SUPERVISOR]: [Application.CARE],
  [UserRole.NURSE_PRACTITIONER]: [Application.CARE],
  [UserRole.CUSTOMER_SUCCESS]: [Application.REPORTS],
};
